import { incomeCalculatorApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CALCULATORS_ACTION_TYPE = createNamedActions('calculators', {
  GET_CALCULATORS: 'GET_CALCULATORS',
});

const calculators = new schema.Entity('calculators', {}, { idAttribute: 'name' });

export const getCalculatorsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await incomeCalculatorApi.getInfo();

  return dispatch({
    type: CALCULATORS_ACTION_TYPE.GET_CALCULATORS,
    payload: normalize(data, [calculators]).entities.calculators,
  });
});
